import { CLAIM_DETAILS_CONSTANTS } from "../../constants";
import { formFieldsConfigProcessed } from "./config/ClaimDetailsConfig";
import { formFieldsState } from "./state/ClaimDetailsState";
import { formFieldsValidation } from "./validations/ClaimDetailsValidations";

export const formName = CLAIM_DETAILS_CONSTANTS.FORM_NAME;
export const formHeader = CLAIM_DETAILS_CONSTANTS.FORM_HEADER;
export const formDescription = CLAIM_DETAILS_CONSTANTS.FORM_DESCRIPTION;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;
export const formState = formFieldsState;
